import Link from 'next/link';
import { HTMLProps, ReactNode } from 'react';

import { colors } from '@scripts/gds';

import Separator from './Separator';

export interface BreadcrumbsItemProps extends HTMLProps<HTMLLIElement> {
    /** Breadcrumbs item content */
    children: ReactNode;
    /** Link address */
    link?: string;
    /** index item */
    isLastItem?: boolean;
    index: number;
}

export const BreadcrumbsItem = ({ link, children, isLastItem, index }: BreadcrumbsItemProps) => {
    return (
        <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
            css={{ display: 'flex', alignItems: 'center' }}
        >
            {link ? (
                <Link legacyBehavior href={link} passHref prefetch={false}>
                    <a
                        aria-label={link}
                        itemProp="item"
                        css={{
                            ':hover': { color: colors.primary },
                            transition: 'color 0.3s ease',
                        }}
                    >
                        <span itemProp="name">{children}</span>
                    </a>
                </Link>
            ) : (
                <span>{children}</span>
            )}
            {children ? (
                <div css={{ ...(isLastItem && { display: 'none' }) }}>
                    <Separator />
                </div>
            ) : null}

            <meta itemProp="position" content={String(index)} />
        </li>
    );
};

export default BreadcrumbsItem;
